const REACT_BASE = process.env.REACT_APP_CLIENT_API;

export default REACT_BASE;
